import type { PetDefinition } from "@/pet/types";

/** Reserved for raid/PvP public pet art — no-op for now. */
export async function syncEquippedPetPublic(
  _userId: string,
  _equipped: PetDefinition | null,
): Promise<void> {}
